// in src/posts.js
import * as React from "react";
// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  TextField,
  TextInput,
  EditButton,
  DeleteButton,
  FormTab,
  TabbedForm,
  DateField,
} from "react-admin";

const ConfigAdminFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="description" alwaysOn resettable/>
  </Filter>
);

const EntryTitle = ({ record }) => {
  return <span>Entry: {record ? `${record.description}` : ""}</span>;
};

export const ConfigAdminList = (props) => (
  <List {...props} filters={<ConfigAdminFilter />} exporter={false} bulkActionButtons={false}>
    <Datagrid>
      <TextField source="description" />
      <DateField label="Last Update" source="lastupdate" locales="lt" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

export const ConfigAdminShow = (props) => (
  <Show title={<EntryTitle />} {...props}>
    <TabbedForm redirect={false}>
      <FormTab label="Description">
        <TextField source="id" />
        <TextField source="description" />
        <TextField source="comments" />
      </FormTab>
      <FormTab label="Introduction">
        <TextInput label="Title" source="title" />
        <TextInput label="Slogan" source="slogan" />
        <TextInput label="Image" source="image" />
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
      <FormTab label="Status">
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
    </TabbedForm>
  </Show>
);

export const ConfigAdminCreate = (props) => (
  <Create {...props} undoable={false}>
    <TabbedForm>
      <FormTab label="Description">
        <TextInput source="id" label="Id" />
        <TextInput source="description" />
        <TextInput source="comments" />
      </FormTab>
      <FormTab label="Introduction">
        <TextInput label="Title" source="title" />
        <TextInput label="Slogan" source="slogan" />
        <TextInput label="Image" source="image" />
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
    </TabbedForm>
  </Create>
);

export const ConfigAdminEdit = (props) => (
  <Edit title={<EntryTitle />} {...props} undoable={false}>
    <TabbedForm>
      <FormTab label="Description">
        <TextField source="id" />
        <TextInput source="description" />
        <TextInput source="comments" />
      </FormTab>
      <FormTab label="Introduction">
        <TextInput label="Title" source="title" />
        <TextInput label="Slogan" source="slogan" />
        <TextInput label="Image" source="image" />
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
      <FormTab label="Status">
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
    </TabbedForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/configAdmin.js